

import React, { useState, forwardRef, useImperativeHandle  ,useRef,useEffect} from 'react';
import {Modal} from 'react-bootstrap';
 import { Dropdown } from 'react-bootstrap';
 import axios from "axios";
  import { useNavigate ,Link} from "react-router-dom";
  import swal from 'sweetalert';
  import InviteCustomer3 from '../../jsx/constant/ModalList2 copy 2';
import { useReactToPrint } from "react-to-print";

const InviteCustomer = forwardRef((props, ref) => {
    const [inviteModal , setInviteModal] = useState(false);
    const [Name,setName] = useState()
    const [QuantityInStock,setQuantityInStock] = useState('')
    const [ItemPrice,setItemPrice]= useState('')
   // const [AreaName,setAreaName] = useState('')
   const [newtable, setNewtable] = useState([]);
   const userdata1 = localStorage.getItem('USER_data');
   const userData = JSON.parse(userdata1);
     const userid = userData.id;
   const invite3 = useRef();

    const [hideshow, sethideshow] = useState(false)
    const [status, setStatus] = useState();
     const [data, setData] = useState([])
     const [hideshow2, sethideshow2] = useState(false)
     const [tajeenlist, settajeenlist] = useState([])
     const [intdata, setIntdata] = useState([])

  //  const { AreaID } = useParams();
  const navigate = useNavigate();

  useImperativeHandle(ref, () => ({
    showInviteModal() {
        setInviteModal(true)
         getcities();
        getint();
        gettajeenlist();
        getfooditem();
    }

  }))      ;
  const hideInviteModal =()=> {
    sethideshow(false)
    setInviteModal(false)
    setCalculatedhowmany(0)
    sethideshow2(false)
setFoodItemint([])
setIngredientGroups([])

}
        

    /////////////////////////////////////
    const [color, setColor] = useState('blue')

             const [tableData, setTableData] = useState([]);
             const [expences, setexpences] = useState({});

           const handleEdit = async (id, field, value) => {
   setColor('red')
             const updatedData = tableData.map((row) =>
              row.id === id ? { ...row, [field]: value } : row
             );
             setTableData(updatedData);
              //const formData = new FormData();
                    // ItemID   Name  CategoryID  StorageID   ItemPrice   QuantityInStock   UserID 

           //  formData.append('_method', 'PATCH')
           // formData.append('ItemID', id);
            // formData.append('Name', value);
            // formData.append('UserID', "1");
           const error = await axios.put(`https://suhba.education.com.ly/back/api/food_items/${id}`, {
            [field]: value,  })
            .catch(function (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  });
                
             } 
            // console.log(formData);
            const [foodItem, setFoodItem] = useState({
                Name: '',
                CategoryID: '',
                StorageID: '',
                ItemPrice: '',
                QuantityInStock: '1',
                UserID: userid,
                status:'متوفر'
              });

            ///////////////////////////////////////////////
      const getcities = () => {
        axios.get('https://suhba.education.com.ly/back/api/food_items')
         .then(({ data }) => {
            setData(data)
         })}

         const [currentPage , setCurrentPage] = useState(1);
         const recordsPage = 8;
         //const lastIndex = currentPage * recordsPage;
        // const firstIndex = lastIndex - recordsPage;   
        // const records = data.slice(firstIndex, lastIndex);
       //  const npage = Math.ceil(data.length / recordsPage)
     //    const number = [...Array(npage + 1).keys()].slice(1)
     const input = document.querySelector('input[name="city"]');
     if(input)
{
     input.addEventListener('invalid', function (event) {
       if (event.target.validity.valueMissing) {
         event.target.setCustomValidity('الرجاء ادخال اسم الاداة');
       } 
     })
     
     input.addEventListener('change', function (event) {
       event.target.setCustomValidity('');
     })}
        
    
       

      useEffect(() => {
        // getcities();
        // getint();
        // getfooditem();
       // getfooditeming();

    }, [])
    //console.log(foodItem)
  
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;   
    const records = data.slice(firstIndex, lastIndex);
    const npage = Math.ceil(data.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    //------------------------------------------------------------------------
    const handleInputChange = () => {
        setInviteModal()
      };
    const [statusPriority, setStatusPriority] = useState([]);
  
    const handleAction =  async(id, field, value) => {
            let temp = statusPriority.map((data) => {
      if (id === data.id) {
        return { ...data, status: value };
      }
      return data;
    });
    setStatusPriority(temp);
        const formData = new FormData();
        formData.append('_method', 'PATCH')
       formData.append('ItemID', id);
        formData.append('status', value);
        formData.append('UserID', userid);
       // console.log(formData)
       // console.log(id);
    const error = await axios.put(`https://suhba.education.com.ly/back/api/food_items/${id}`, {
       [field]: value,  });
           if (error.response) {
             console.log(error.response.data);
             console.log(error.response.status);
             console.log(error.response.headers);
           } else if (error.request) {
             console.log(error.request);
           } else {
             console.log('Error', error.message);
           }
           console.log(error.config);
          } 
          const [selectedItem, setSelectedItem] = useState();
//-------------------------------------------------------------------------------
          const handleSelect = (eventKey, rowIndex) => {
            const updatedData = [...data];
            updatedData[rowIndex].status = eventKey;
            setSelectedItem(eventKey) 
            //console.log(eventKey)

                       setData(updatedData);//console.log(rowIndex);
          };
          const [foodIteming, setFoodIteming] = useState([])
          const [foodItems, setFoodItems] = useState([])
            const [foodItemint, setFoodItemint] = useState({
            FoodItemID:'',
            IngredientID:'',
          Quantity:'',
          ForHowMany:'',
          UserID: userid,
          });
          const getfooditem = () => {
            axios.get('https://suhba.education.com.ly/back/api/getlast')
             .then(({ data }) => {
              setFoodItems(data.FoodItem)
             })}
              const gettajeenlist = () => {
            axios.get('https://suhba.education.com.ly/back/api/getonly')
             .then(({ data }) => {
              settajeenlist(data.FoodItem)
             })}
             const getfooditeming = (id) => {
             // console.log('name',id)
              axios.get(`https://suhba.education.com.ly/back/api/getT/${id}`)
               .then(({ data }) => {
                setFoodIteming(data)

                console.log('data',data)
               }) .catch(function (error) {
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log(error.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);
                }
                console.log(error.config);
              });
            
            }
              console.log('get data',foodIteming)

          const getint = () => {
            axios.get('https://suhba.education.com.ly/back/api/getint')
             .then(({ data }) => {
              setIntdata(data.Ingredient)
             })
             .catch(function (error) {
              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
              }
              console.log(error.config);
            });
             
             }
             const [amount, setAmount] = useState(0);

             const handleInputChange2 = (e) => {
              const { name, value } = e.target;
              setFoodItemint((prevData) => ({
                ...prevData,
                [name]: value,
              }));
              console.log('name',name)

              if (name ==="FoodItemID")
              {
               console.log('value',value)
               foodItems.map((item) => {
        if (value == item.ItemID) {
                       setName(item.Name)


        }
  
      })
              getfooditeming(value)
            }
              else {
              console.log('setAmount',value)

                setAmount(value)} 
             
              
              
            };  

             
                const [calculatedRows, setCalculatedRows] = useState([]);
             const [calculatedhowmany, setCalculatedhowmany] = useState('');
             const [ForHowMany, setForHowMany] = useState(0);
const [ingredientGroups, setIngredientGroups] = useState([]); // accumulate all ingredient sets
const calculate = (name) => {
  if (!ForHowMany || !foodIteming.length) return;

  const itemName = foodItems.find(item => item.ItemID == foodItemint.FoodItemID)?.Name || 'صنف غير معروف';

  let howManyRatio = 0;

  const item = tajeenlist.find(food => food.Name === name);
  if (item) {
    howManyRatio = parseFloat(ForHowMany) / foodIteming[0].ForHowMany;
  }

  // 🛑 Check for duplicate ItemID
  setIngredientGroups(prev => {
    const alreadyExists = prev.some(group => group.ItemID === foodItemint.FoodItemID);
    if (alreadyExists) {
      swal('تمت إضافة هذا الصنف بالفعل'); // Optional: show a message
      return prev; // Do not add again
    }

    const newRows = foodIteming.map(entry => {
      const calculatedAmount = ((ForHowMany / entry.ForHowMany) * entry.Quantity).toFixed(2);
      return {
        IngredientID: entry.IngredientID,
        IngName: entry.IngredientName,
        Amount: parseFloat(calculatedAmount),
        IngCategoryID: entry.IngCategoryID,
        UserID: userid,
        IngCatName: entry.IngCatName
      };
    });

    const newGroup = {
      ItemID: foodItemint.FoodItemID,
      Name: itemName,
      ForHowMany: ForHowMany,
      calculatedhowmany: howManyRatio.toFixed(2),
      ingredients: newRows
    };

    return [...prev, newGroup];
  });

  sethideshow2(true);
  setForHowMany('');
  setFoodItemint({ FoodItemID: '' });
};


     
const calculate610 = () => {
                            console.log('amount', ForHowMany);
setCalculatedhowmany(0)
              const updatedRows = [...calculatedRows];
 setCalculatedhowmany(parseFloat(ForHowMany)/foodIteming[0].ForHowMany)
                          console.log('calculatedhowmany', foodIteming[0].ForHowMany)
              foodIteming.forEach((entry) => { 
                 const calculatedAmount = ((ForHowMany / entry.ForHowMany) * entry.Quantity).toFixed(2); // Limit to 2 decimal places
            

                  updatedRows.push({
                    IngredientID: entry.IngredientID,
                    IngName: entry.IngredientName,
                    Amount: parseFloat(calculatedAmount), // Ensure it's still a number
                    IngCategoryID: entry.IngCategoryID,
                    UserID: userid,
                    IngCatName: entry.IngCatName,
                  });
                
              });
            sethideshow2(true)
              setCalculatedRows(updatedRows);
            };
            const componentRef = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentRef.current, // this will reference the full table content
    documentTitle: "Userdata",
  });

           
            console.log('calculatedRows',calculatedRows)
            return(
        <>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal}  centered>                
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1"> مقادير الاصناف </h1>
                       
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={hideInviteModal}></button>
                    </div>
                           
                      <div className="modal-body py-1 px-3">
                 <form  >
                         
                        <div className="row">
                            <div className="col-xl-12">
                      
                            <div className="row">
                            <div className="col-xl-6 ">
                                <label className="form-label mt-3">اسم الصنف</label>
                                 <select className="default-select form-control" name="FoodItemID" defaultValue={foodItemint.FoodItemID} onChange={handleInputChange2}>
                                 <option  data-display="Select">اختر من القائمة</option>
                                 {
                                   foodItems.map((row)=>(
                                  <option key={row.ItemID} value={row.ItemID}>
                                            {row.Name}
                                    </option>
                                     ))}    
                                 </select> 
                                   </div>
                                   <div className="col-xl-6">
                                <label className="form-label mt-3">دالك لعدد</label>
                                <input type="number" className="form-control" name="ForHowMany" Value={ForHowMany} onChange={(e) =>setForHowMany(e.target.value)}                      />
                                  </div>
                                   
                  </div>
                           

                                 <input type="text" hidden="true" name="UserID" value={userid} />
                                <input type="text"  id ="Hallid" hidden="true" name="EexpenseID" defaultValue={props.ExpenseId} />

                            </div>
                        </div>                                
                    


                        <div className="col-xl-12 pt-2 pe-3"   >
                         
 <Link   className="btn btn-primary btn-sm btn-block"
                                onClick={(e) =>calculate(Name,ForHowMany)}
                            > اضف الى القائمة 
                            </Link>
                    </div> 
                     <div hidden={!hideshow2} ref={componentRef}  dir="rtl" 
                     className="table-responsive verticle-middle active-projects task-table m-3 p-3">
                              <div className="col-xl-6 ">
    
                                  </div> 
                                  <div className="col-xl-12 ">
{ingredientGroups.map((group, i) => (
  <div key={i} className="mb-4 p-3 border rounded" dir="rtl">
    <div className="d-flex justify-content-between mb-2">
      <div><strong>اسم الصنف:</strong> {group.Name}</div>
      <div><strong>العدد الكلي:</strong> {group.ForHowMany}</div>
      <div><strong>طاجين:</strong> {group.calculatedhowmany}</div>
    </div>
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>اسم المكون</th>
          <th>الكمية</th>
          <th>الوحدة</th>
        </tr>
      </thead>
      <tbody>
        {group.ingredients.map((ing, index) => (
          <tr key={index}>
            <td>{ing.IngName}</td>
            <td>{ing.Amount}</td>
            <td>{ing.IngCatName}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
))}



  {/* <div className="d-flex justify-content-around flex-wrap">
    <div className="d-flex align-items-center gap-2 mt-3">
      <label className="form-label m-0">اسم الصنف</label>
      <label className="form-label m-0" style={{ color: 'green', fontWeight: 'bold' }}>{Name}</label>
    </div>
    <div className="d-flex align-items-center gap-2 mt-3">
      <label className="form-label m-0">العدد الكلي للقطع</label>
      <label className="form-label m-0" style={{ color: 'green', fontWeight: 'bold' }}>{ForHowMany}</label>
    </div>
  </div>
</div>
                <table className="table table-bordered verticle-middle table-responsive-sm" style={{ marginBottom:'0px',borderCollapse: "unset", borderWidth: '1 px' }}>
                
                                     <thead>
                                        <tr className="center" >
                                            <th scope="col">اسم المكون</th>
                                            <th scope="col">الكمية</th>
                                            <th scope="col">الوحدة</th>

                                         </tr>
                                    </thead>
                                    <tbody>
                                   
          {     calculatedRows.length > 0 &&     calculatedRows.map((row, index) => (
            <tr key={index}>
              <td>{row.IngName}</td>
              <td>{row.Amount}</td>
              <td> {row.IngCatName}</td>
            </tr>
          ))}
         
                                    </tbody>
                                </table> */}
                                
</div>
      </div>
  
<div className="col-xl-12 pt-2  ">
                       <Link hidden={!hideshow2} className="btn btn-primary btn-sm btn-block"
                                onClick={(e) =>generatePDF()}
                            > طباعة
                            </Link>         
 
                               
                                                                                                </div>
                                                                                                </form>

</div>



                           
                                                  
                  
                   
                </div>               
            </Modal>
           
        </>
    )
})
export default InviteCustomer;

